module.exports = __webpack_public_path__ + "static/media/landing-logo.68cdb08d.png";